package ai.wagemix.web.screens.marketing

import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.logic.marketing.WMDefaultMarketingChromePresenter
import ai.wagemix.logic.marketing.WMMarketingChromePresenter
import ai.wagemix.logic.marketing.WMMarketingChromePresenter.Action
import ai.wagemix.logic.marketing.WMMarketingChromePresenter.Event
import ai.wagemix.net.models.WMSession
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import com.fsryan.foundation.web.screens.FSWebViewModel
import com.fsryan.foundation.web.screens.FSWebViewStateHolder

interface WMMarketingChromeWebViewStateHolder: FSWebViewStateHolder {
    /** `false` until the first session event; the header shows no session actions before it. */
    val sessionResolvedState: State<Boolean>
    val sessionState: State<WMSession?>
}

abstract class WMBaseMarketingChromeWebViewModel<
    E: Event,
    A: Action,
    PR: WMMarketingChromePresenter<E, A>
>(
    presenter: PR,
    protected val externalNavigation: (WMNavigationRequest) -> Unit
): FSWebViewModel<E, A, PR>(presenter), WMMarketingChromeWebViewStateHolder {

    override val sessionResolvedState: State<Boolean> get() = _sessionResolvedState
    protected val _sessionResolvedState = mutableStateOf(false)

    override val sessionState: State<WMSession?> get() = _sessionState
    protected val _sessionState = mutableStateOf<WMSession?>(null)

    override fun customEventHandling(event: E) {
        super.customEventHandling(event)
        with(event) {
            sessionUpdate?.let {
                _sessionState.value = it.value
                _sessionResolvedState.value = true
            }
            navigationUpdate?.let { externalNavigation(it) }
        }
    }

    fun userRequestedOpenApp(extendedProperties: Map<String, Any> = emptyMap()) {
        presenter.userRequestedOpenApp(extendedProperties)
    }
}

typealias WMDefaultMarketingChromeWebViewModel = WMBaseMarketingChromeWebViewModel<Event.Base, Action.Base, WMDefaultMarketingChromePresenter>

fun createDefaultMarketingChromeWebViewModel(
    presenter: WMDefaultMarketingChromePresenter,
    externalNavigation: (WMNavigationRequest) -> Unit
): WMDefaultMarketingChromeWebViewModel = object: WMDefaultMarketingChromeWebViewModel(presenter, externalNavigation) {}
